import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Farm } from '../../models/farm.model';

@Injectable({
  providedIn: 'root',
})
export class FarmService {
  private readonly http = inject(HttpClient);

  getFarms(): Observable<Farm[]> {
    return this.http.get<Farm[]>(`${environment.apiUrl}/farm`);
  }
}
